import { JSX } from 'react/jsx-runtime';
import { WebPaymentMethod } from '../iap.types';
import { paymentMethodsIcons, paymentMethodsNames } from './Config';

/**
 * Payment method button.
 * @param
 * @returns
 */
export function PaymentMethodButton({
  paymentMethod,
  onClick,
}: {
  paymentMethod: WebPaymentMethod;
  onClick: JSX.MouseEventHandler<HTMLDivElement>;
}) {
  /**
   * Render payment method button.
   */
  return (
    <div class="paymentMethod" id="paymentMethodTemplate" onClick={onClick}>
      <div class="paymentMethodLogo" id="paymentMethodLogo">
        {paymentMethodsIcons[paymentMethod]}
      </div>
      <div
        id="paymentMethodName"
        class="paymentMethodName"
        dangerouslySetInnerHTML={{
          __html: paymentMethodsNames[paymentMethod](),
        }}
      />
    </div>
  );
}
